/**
 * Web Pagination Context
 *
 */

import React from 'react'

const Context = React.createContext({ pagination: {} })

export default Context
